// @ts-nocheck
import * as React from 'react';
import './dropdown.scss';
import { useOutsideAlerter } from 'utils/helpers';
import { Select, Tag, Dropdown } from 'antd';
const { Option } = Select;

export type OptionType = {
	displayName: string;
	value: string;
};
export type OptionSelection = OptionType | OptionType[] | null; // extracted alias

interface Props extends React.PropsWithChildren<any> {
	options: ReadonlyArray<Option>;
	placeholder: string;
	updateHandler: Function;
	selectedOption?: Option;
	isAutocomplete?: boolean;
	onBlur?: (e: React.FocusEvent<any>) => void;
}

const tagRender = (props: CustomTagProps) => {
	const { label, closable, onClose } = props;
	const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
		event.preventDefault();
		event.stopPropagation();
	};
	return (
		<Tag onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
			{label}
		</Tag>
	);
};

const MultiSelectDropdown: React.FunctionComponent<any> = (props: Props) => {
	const { options, placeholder, updateHandler, selectedOption, isMultiselect, onBlur } = props;

	const [_, toggleItems] = React.useState(false);
	const wrapperRef = React.useRef(null);
	const [selectedItem, setSelectedItem] = React.useState<any>(null);
	const [value, setInputValue] = React.useState(selectedItem?.label);
	React.useEffect(() => {
		if (selectedOption) {
			setSelectedItem(selectedOption);
			setInputValue(selectedOption.label);
		} else {
			setInputValue('');
			setSelectedItem(null);
		}
	}, [selectedOption]);

	useOutsideAlerter(wrapperRef, () => {
		toggleItems(false);
	});

	const handleSelectDropdownItem = React.useCallback(
		(item) => {
			setSelectedItem(item);
			toggleItems(false);
			updateHandler(item);
		},
		[toggleItems, updateHandler, setSelectedItem]
	);

	let updatedOptions = options?.map((item) => {
		return {
			label: item?.displayName,
			value: item?.value,
		};
	});

	if (isMultiselect) {
		return (
			<Select
				mode="multiple"
				placeholder={placeholder}
				tagRender={tagRender}
				filterOption={(a, options) => {
					return options.label.match(new RegExp(a, 'i'));
				}}
				value={selectedOption || []}
				defaultValue={selectedOption || []}
				onChange={handleSelectDropdownItem}
				onMouseDown={(e) => e.stopPropagation()}
				onBlur={onBlur}
				options={updatedOptions}
			></Select>
		);
	}

	return (
		<Select
			value={selectedOption?.displayName}
			style={{ width: '100%', height: '2rem', minWidth: '10rem' }}
			onChange={(value) => {
				let item = _.find(options, (o) => o?.value.toString() === value.toString());

				handleSelectDropdownItem(item);
			}}
			onMouseDown={(e) => e.stopPropagation()}
			placeholder="Select a Value"
		>
			{_.map(options, (option) => (
				<Option key={option.value}>{option.displayName}</Option>
			))}
		</Select>
	);
};

Dropdown.defaultProps = {
	placeholder: 'Select a Value',
	updateHandler: () => {},
};

export default MultiSelectDropdown;
